import { render, staticRenderFns } from "./pay-act-item.vue?vue&type=template&id=2b0dd72b&scoped=true&"
import script from "./pay-act-item.vue?vue&type=script&setup=true&lang=ts&"
export * from "./pay-act-item.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./pay-act-item.vue?vue&type=style&index=0&id=2b0dd72b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0dd72b",
  null
  
)

export default component.exports